// Textos del indicador de conexión y del aviso "Sin conexión" (modo
// contingencia, paso 2). Ver app/components/indicador-conexion.tsx.
import { defineTextos } from '../textos.ts';

export const textosConexion = defineTextos({
  etiqueta: 'Estado de la conexión',
  comprobando: 'Comprobando…',
  enLinea: 'En línea · todo guardado',
  guardando1: 'Guardando 1 cambio…',
  guardandoN: 'Guardando {n} cambios…',
  sinVivo: 'Sin actualizaciones en vivo',
  pendienteLocal1: '1 pedido solo en este equipo',
  pendienteLocalN: '{n} pedidos solo en este equipo',
  sinConexion: 'Sin conexión',
  sinConexionN: 'Sin conexión · {n} sin subir',

  explicaComprobando: 'Todavía no hay una respuesta reciente del servidor. Espera antes de cerrar o recargar.',
  explicaEnLinea: 'El servidor responde y todo lo que hiciste quedó guardado.',
  explicaGuardando: 'Hay cambios enviados que el servidor todavía no confirmó. No cierres ni recargues.',
  explicaSinVivo: 'El servidor responde, pero no llegan en vivo los pedidos de otros equipos. Si dura más de un minuto, recarga la página.',
  explicaPendienteLocal: 'Hay pedidos de la caja de contingencia que todavía están solo en este equipo. Se suben solos cuando hay conexión; si alguno requiere revisión, ábrelo en la caja. No borres los datos del navegador.',
  abrirCaja: 'Abrir caja de contingencia',
  explicaSinConexion: 'El servidor no responde. Lo que hagas ahora no se guarda. Si estás en wifi, apágalo para usar datos móviles.',

  ultimoGuardado: 'Último cambio guardado',
  ningunoAun: 'ninguno todavía',
  servidorRespondio: 'El servidor respondió',
  copiaContingencia: 'Copia para trabajar sin internet',
  haceSeg: 'hace {s} s',
  haceMin: 'hace {m} min',
  todaviaNo: 'todavía no',
  esperandoConfirmacion: 'Esperando confirmación',
  comprobarAhora: 'Comprobar ahora',

  avisoTitulo: 'Sin conexión con el servidor.',
  avisoTexto: 'Lo que hagas ahora no se guarda. Si estás en wifi, apágalo para usar datos móviles.',
  avisoTextoCaja: 'Las pantallas de siempre no guardan nada: usa la caja de contingencia. Si estás en wifi, apágalo para usar datos móviles.',
  avisoReintentar: 'Reintentar',
}, {
  etiqueta: 'Connection status',
  comprobando: 'Checking…',
  enLinea: 'Online · all saved',
  guardando1: 'Saving 1 change…',
  guardandoN: 'Saving {n} changes…',
  sinVivo: 'No live updates',
  pendienteLocal1: '1 order only on this device',
  pendienteLocalN: '{n} orders only on this device',
  sinConexion: 'Offline',
  sinConexionN: 'Offline · {n} not uploaded',

  explicaComprobando: 'No recent answer from the server yet. Wait before closing or reloading.',
  explicaEnLinea: 'The server answers and everything you did is saved.',
  explicaGuardando: 'Some changes were sent but the server has not confirmed them yet. Do not close or reload.',
  explicaSinVivo: 'The server answers, but orders from other devices are not arriving live. If it lasts more than a minute, reload the page.',
  explicaPendienteLocal: 'Some contingency orders are still only on this device. They upload on their own when there is a connection; if one needs review, open it in the register. Do not clear the browser data.',
  abrirCaja: 'Open contingency register',
  explicaSinConexion: 'The server does not answer. What you do now is not saved. If you are on wifi, turn it off to use mobile data.',

  ultimoGuardado: 'Last change saved',
  ningunoAun: 'none yet',
  servidorRespondio: 'Server answered',
  copiaContingencia: 'Copy for working offline',
  haceSeg: '{s} s ago',
  haceMin: '{m} min ago',
  todaviaNo: 'not yet',
  esperandoConfirmacion: 'Waiting for confirmation',
  comprobarAhora: 'Check now',

  avisoTitulo: 'No connection to the server.',
  avisoTexto: 'What you do now is not saved. If you are on wifi, turn it off to use mobile data.',
  avisoTextoCaja: 'The usual screens do not save anything: use the contingency register. If you are on wifi, turn it off to use mobile data.',
  avisoReintentar: 'Retry',
});
